
// frontend/src/slices/preShiftApiSlice.js
import { apiSlice } from './apiSlice';
 
const PRESHIFT_URL = '/api/preshifts';
 
export const preShiftApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all pre-shifts (admin only)
    getPreShifts: builder.query({
      query: (params) => ({
        url: PRESHIFT_URL,
        params,
      }),
      providesTags: ['PreShift'],
    }),
 
    // Get my pre-shifts (for ward managers)
    getMyPreShifts: builder.query({
      query: () => `${PRESHIFT_URL}/myrequests`,
      providesTags: ['PreShift'],
    }),
 
    // Get pre-shift by ID
    getPreShiftById: builder.query({
      query: (id) => `${PRESHIFT_URL}/${id}`,
      providesTags: (result, error, id) => [{ type: 'PreShift', id }],
    }),
 
    // Create pre-shift
    createPreShift: builder.mutation({
      query: (data) => ({
        url: PRESHIFT_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PreShift'],
    }),
 
    // Update pre-shift
    updatePreShift: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${PRESHIFT_URL}/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'PreShift', id },
        'PreShift',
      ],
    }),
 
    // Approve pre-shift
    approvePreShift: builder.mutation({
      query: ({ id, approvalNotes }) => ({
        url: `${PRESHIFT_URL}/${id}/approve`,
        method: 'POST',
        body: { approvalNotes },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'PreShift', id },
        'PreShift',
        'Shift', // Invalidate shifts cache as a new shift is created
      ],
    }),
 
    // Reject pre-shift
    rejectPreShift: builder.mutation({
      query: ({ id, rejectionReason }) => ({
        url: `${PRESHIFT_URL}/${id}/reject`,
        method: 'POST',
        body: { rejectionReason },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'PreShift', id },
        'PreShift',
      ],
    }),
 
    // Delete pre-shift
    deletePreShift: builder.mutation({
      query: (id) => ({
        url: `${PRESHIFT_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PreShift'],
    }),
 
    // Get pre-shift statistics
    getPreShiftStats: builder.query({
      query: () => `${PRESHIFT_URL}/stats`,
      providesTags: ['PreShift'],
    }),
 
    // Get pre-shift analytics (trends/breakdowns by reason, specials reason,
    // category, directorate, ward, requester, approver, monthly volume, and
    // top rejection reasons) — powers PreShiftAnalyticsDashboard.
    getPreShiftAnalytics: builder.query({
      query: (params) => ({
        url: `${PRESHIFT_URL}/analytics`,
        params,
      }),
      providesTags: ['PreShift'],
    }),
  }),
});
 
export const {
  useGetPreShiftsQuery,
  useGetMyPreShiftsQuery,
  useGetPreShiftByIdQuery,
  useCreatePreShiftMutation,
  useUpdatePreShiftMutation,
  useApprovePreShiftMutation,
  useRejectPreShiftMutation,
  useDeletePreShiftMutation,
  useGetPreShiftStatsQuery,
  useGetPreShiftAnalyticsQuery,
} = preShiftApiSlice;